import { jsx as _jsx } from "react/jsx-runtime";
/* oxlint-disable typescript/consistent-indexed-object-style -- LINTER migration follow up */
import i18n, { changeLanguage, use as i18nUse } from "i18next";
import { memo } from "react";
import { useTranslation as _useTranslation, I18nextProvider, Trans as I18nTrans, initReactI18next, } from "react-i18next";
// eslint-disable-next-line import/no-unassigned-import -- module augmentation for i18next types
import "./@types/i18next.js";
void i18nUse(initReactI18next).init({
    resources: { fr: { translation: {} } },
    // Keys are flat strings: registering "a.b" must not overwrite an already registered "a.b.c".
    keySeparator: false,
    defaultNS: "translation",
    lng: "fr",
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    saveMissing: true, // This is necessary fo the missingKey event to work
    // Without a handler, i18next stores a missing key as its own value: it would never be missing again,
    // so a failed full-locale load could not be retried.
    missingKeyHandler: () => undefined,
});
/** Called by the code the front `i18n-inline` vite plugin appends to each module using translations. */
export function registerTranslations(translations) {
    i18n.addResources("fr", "translation", translations);
}
let isFullLocaleRequested = false;
/** Safety net for a key the build could not see statically (e.g. built from runtime data). */
function loadFullLocale(onFailure) {
    if (isFullLocaleRequested) {
        return;
    }
    isFullLocaleRequested = true;
    void (async () => {
        try {
            const { fr: translations } = await import("./locales/fr");
            registerTranslations(translations);
        }
        catch (exception) {
            // The key stays missing, so its next render retries, e.g. once the connection is back.
            isFullLocaleRequested = false;
            onFailure(exception);
            return;
        }
        // Same language: only emits `languageChanged`, which re-renders the components that displayed a missing key.
        await changeLanguage("fr");
    })();
}
/** Reports missing keys and loads the full locale so they still get translated. */
export function registerMissingI18nKey(alertDevs) {
    const reportedKeys = new Set();
    // oxlint-disable-next-line max-params
    const missingKeyHandler = (lngs, ns, key, fallbackValue, updateMissing, options) => {
        // A missing key is reported on every render until the full locale is loaded.
        if (!reportedKeys.has(key)) {
            reportedKeys.add(key);
            alertDevs({
                error: new Error(`[i18n] Missing key: ${key}`),
                context: { lngs, ns, key, fallbackValue, updateMissing, options },
            });
        }
        loadFullLocale((exception) => {
            alertDevs({ error: new Error("[i18n] Failed to load the full locale"), exception });
        });
    };
    i18n.on("missingKey", missingKeyHandler);
}
export { _useTranslation as useTranslation };
export const Trans = memo((props) => {
    return _jsx(I18nTrans, { ...props });
});
Trans.displayName = "Trans";
export { I18nextProvider };
